// Shared signal for expanding the chat sidebar (AppShell) from elsewhere in the app — e.g. when a
// project is created from the onboarding chat, the sidebar should expand (if collapsed) so the chat
// carries over into the project view. AppShell owns the collapse state, so we notify it via a
// same-tab custom event (the `storage` event only fires cross-tab) and also persist the preference so
// a full reload lands expanded too.

export const SIDEBAR_COLLAPSED_KEY = 'loopqa-sidebar-collapsed'
const EXPAND_SIDEBAR_EVENT = 'loopqa:expand-sidebar'

// Ask AppShell to expand the chat sidebar. Persists the un-collapsed preference and fires the event
// AppShell listens for so an already-mounted shell reacts without a reload.
export function requestSidebarExpand() {
  try { localStorage.setItem(SIDEBAR_COLLAPSED_KEY, '0') } catch { /* ignore */ }
  try { window.dispatchEvent(new Event(EXPAND_SIDEBAR_EVENT)) } catch { /* ignore */ }
}

export function onSidebarExpandRequest(handler: () => void): () => void {
  window.addEventListener(EXPAND_SIDEBAR_EVENT, handler)
  return () => window.removeEventListener(EXPAND_SIDEBAR_EVENT, handler)
}
